<a
  *ngIf="!loading; else loadingEl"
  (click)="pageSelect.emit($event)"
  class="thumbnail"
  [ngClass]="{ 'selected': selected}"
>
  <div
    *ngIf="page.label"
    class="thumbnail-label"
    [ngStyle]="{ 'background-color': page.color }"
    [matTooltip]="page.tooltip"
  >
    {{ page.label }}
  </div>
  <img [src]="page.thumbnail" />
  <div
    class="text-center page-num"
    [ngStyle]="{ 'background-color': page.color}"
  >
    {{ page.pageNum }} <ng-container *ngIf="numberOfPages">/ {{ numberOfPages }}</ng-container>
  </div>
</a>

<ng-template #loadingEl>
  <div fxLayout="column" class="thumbnail loading">
    <div fxFlex>&nbsp;</div>
    <div class="text-center page-num">
      {{ page.pageNum }} <ng-container *ngIf="numberOfPages">/ {{ numberOfPages }}</ng-container>
    </div>
  </div>
</ng-template>
